"use strict";
/**
|--------------------------------------------------
| Cookies functions
|--------------------------------------------------
*/

import Modal from "bootstrap/js/dist/modal";
import Offcanvas from "bootstrap/js/dist/offcanvas";

const cookiesPrefix = "loba_";

export const createCookie = (value, days) => {
	// If value is an array of cookies from inputs loop and refresh
	// otherwise just refresh the cookie by its name
	if(NodeList.prototype.isPrototypeOf(value)){
		value.forEach((cookie) => {
			const cookieValue = cookiesPrefix + cookie.value;
			refreshCokkie(cookieValue);
		});
	}else{
		refreshCokkie(value);
	}

	function refreshCokkie(cookieValue) {
		let expires;
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toGMTString();
		} else {
			expires = "";
		}

		document.cookie = cookieValue + "=" + true + expires + "; path=/";
	}
};

export const readCookie = (name) => {
	let nameEQ = name + "="
	let cookies = document.cookie.split(";")
	let readCookie = false
	cookies.forEach((cookie) => {
		while (cookie.startsWith(" ")) {
			cookie = cookie.substring(1, cookie.length)
		}
		if (cookie.startsWith(nameEQ)) {
			readCookie = true
		}
	})
	return readCookie
};

export const readCookiePermissions = (prefix) => {
	const values = getCookies()
	values.forEach((value) => {
		const scripts = document.querySelectorAll('script[type="text/plain"][data-assigned-cookie="'+value+'"]')
		scripts.forEach(script => {
			const newScript = script.cloneNode(true);
			newScript.removeAttribute('type');
			script.parentNode.replaceChild(newScript, script);
		})
		const embeds = document.querySelectorAll('.embed--no-consent[data-assigned-cookie="'+value+'"]')
		embeds.forEach(embed => {
			embed.classList.remove('embed--no-consent')
			const iframe = embed.querySelector('iframe')
			if(!iframe) return;
			iframe.src = iframe.dataset.src
		})
	});
	function getCookies(){
		// Get all
		const cookies = document.cookie.split(";");
		// Filter all cookies with prefix
		const filteredCookies = cookies.filter((cookie) => {
			return cookie.includes(prefix);
		});
		// Clear set cookies
		const cookieNames = []
		filteredCookies.forEach((cookie) => {
			const cookieName = cookie.replace(' ','').replace(prefix,'').split("=")[0];
			cookieNames.push(cookieName);
		});
		return cookieNames;
	}
};

export const eraseCookies = () => {
	let cookies = document.cookie.split(";");
	cookies.forEach((cookie) => {
		let cookieName = cookie.replace(' ','').split("=")[0];
		createCookie(cookieName, -1);
	});
};

export const initDatalayer = () => {
	window.dataLayer = window.dataLayer || [];
	function gtag() {dataLayer.push(arguments);}
	window.gtag = gtag;

	if(localStorage.getItem('consentMode') === null){
		gtag('consent', 'default', {
			'ad_storage': 'denied',
			'analytics_storage': 'denied',
			'personalization_storage': 'denied',
			'functionality_storage': 'denied',
			'security_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied'
		})
	}else{
		gtag('consent', 'default', JSON.parse(localStorage.getItem('consentMode')));
	}
}

export const initCookiesBox = function(cookiesWrapperSelector, changeCookiesSelector, forceOpen = false) {
	const cookiesWrapper = document.querySelector(cookiesWrapperSelector),
		changeCookies = document.querySelectorAll(changeCookiesSelector),
		acceptCookiesBtn = document.querySelector('.cookies__accept'),
		denyCookiesBtn = document.querySelector('.cookies__deny'),
		submitCookiesPreferencesBtn = document.querySelector('.cookies__submit'),
		cookiesDescription = document.querySelector('.cookies__description'),
		cookiesSettings = document.querySelector('.cookies__settings'),
		cookiesSettingsLink = document.querySelector('.cookies__settings-link'),
		cookiesCancel = document.querySelector('.cookies__cancel'),
		header = document.querySelector('header');
	
	if (!cookiesWrapper) {
		console.log('Cookies Box is missing!')
		return;
	};
	
	let cookiesModal;
	if(cookiesWrapper.classList.contains('modal')){
		cookiesModal = new Modal(cookiesWrapper)
		cookiesWrapper.addEventListener('shown.bs.modal', function () {
			addBackdropClass()
		})
	}else{
		cookiesModal = new Offcanvas(cookiesWrapper)
		cookiesWrapper.addEventListener('shown.bs.offcanvas', function () {
			addBackdropClass()
		})
	}

	function addBackdropClass() {
		let backdrops = document.querySelectorAll('.modal-backdrop'); // Get all backdrops
		let latestBackdrop = backdrops[backdrops.length - 1]; // Get the most recent backdrop
		latestBackdrop.classList.add('cookies__box');
	}

	// Show Cookies if not accepted already
	if (!readCookie(cookiesPrefix + "required") || forceOpen) {
		eraseCookies();
		cookiesModal.show();
		document.body.style.overflow = "";
		document.body.style.paddingRight = "";
		if(header) header.style.paddingRight = "";
	} else {
		readCookiePermissions(cookiesPrefix);
	}

	changeCookies.forEach((button) => {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			eraseCookies();
			cookiesModal.show();
			document.body.style.overflow = "";
			document.body.style.paddingRight = "";
			if(header) header.style.paddingRight = "";
		});
	})

	// Accept all Cookies
	acceptCookiesBtn?.addEventListener("click", function (e) {
		e.preventDefault();
		const cookieVal = document.querySelectorAll('input[name=cookie-switch]');
		submitPreferences(cookieVal);
	});

	// Deny all Cookies (except required)
	denyCookiesBtn?.addEventListener("click", function (e) {
		e.preventDefault();
		const cookieVal = document.querySelectorAll('#cookie-required');
		submitPreferences(cookieVal);
	});

	// Submit preferences
	submitCookiesPreferencesBtn?.addEventListener("click", function (e) {
		e.preventDefault();
		const cookieVal = document.querySelectorAll('input[name=cookie-switch]:checked');
		submitPreferences(cookieVal);
	});

	function submitPreferences(cookieVal) {
		createCookie(cookieVal, 365 * 10);
		readCookiePermissions(cookiesPrefix);
		cookiesModal.hide();
		setConsent();
	}

	// open and close cookies preferences
	cookiesSettingsLink?.addEventListener("click", function (e) {
		e.preventDefault();
		cookiesDescription.classList.toggle('d-none');
		cookiesSettings.classList.toggle('d-none');
	})

	cookiesCancel?.addEventListener("click", function (e) {
		e.preventDefault();
		cookiesDescription.classList.toggle('d-none');
		cookiesSettings.classList.toggle('d-none');
	})



};

export const setConsent = () => {
	const consentMode = {
		'ad_storage': readCookie(cookiesPrefix + "ad") ? 'granted' : 'denied',
		'analytics_storage': readCookie(cookiesPrefix + "analytics") ? 'granted' : 'denied',
		'personalization_storage': readCookie(cookiesPrefix + "personalization") ? 'granted' : 'denied',
		'functionality_storage': readCookie(cookiesPrefix + "functionality") ? 'granted' : 'denied',
		'security_storage': readCookie(cookiesPrefix + "security") ? 'granted' : 'denied',
		'ad_user_data': readCookie(cookiesPrefix + "ad_user_data") ? 'granted' : 'denied',
		'ad_personalization': readCookie(cookiesPrefix + "ad_personalization") ? 'granted' : 'denied'
	}
	gtag('consent', 'update', consentMode);
	localStorage.setItem('consentMode', JSON.stringify(consentMode));
}